<script lang="ts">
  import type { EditButton } from './types';
  export let button: EditButton = {
    editUrl: '#',
    text: 'Edit'
  };
</script>

<a
  target="_blank"
  href={button.editUrl}
  class="hidden group-hover:block absolute top-0 right-0 -translate-y-full bg-orange-600 text-white"
  >{button.text}</a
>
